import type { PageContext } from "vike/types";
import type { Data } from "./+data";

// C4: single <title>/og:title owner. Page number in the title keeps paginated
// pages distinguishable in the index ("صفحة N" only beyond page 1).
export default function title(pageContext: PageContext): string | null {
  const data = pageContext.data as Data | undefined;
  if (!data?.store) return null;
  const pageSuffix = data.page > 1 ? ` | صفحة ${data.page}` : "";
  return `تقييمات ${data.store.name}${pageSuffix} | يتفرج`;
}
